{
	"placeholder": {
		"empty": "Write something, or type “/” for blocks…",
		"line": "Type “/” for blocks",
		"heading": "Heading"
	},
	"image": {
		"unavailable": "Image unavailable"
	},
	"attachment": {
		"unnamed": "File",
		"open": "Download {{name}}",
		"play": "Play {{name}}",
		"download": "Download {{name}}",
		"notPlayable": "This file can't be played here. Download it instead.",
		"player": "Video: {{name}}"
	},
	"upload": {
		"uploading": "Uploading {{name}}…",
		"tooLarge": "{{name}} is larger than {{max}}."
	},
	"format": {
		"bold": "Bold",
		"italic": "Italic",
		"underline": "Underline",
		"strike": "Strikethrough",
		"code": "Inline code",
		"link": "Link",
		"linkPlaceholder": "Paste a link, or leave empty to remove",
		"apply": "Apply"
	},
	"block": {
		"addBelow": "Add a block below",
		"handle": "Block menu",
		"handleHint": "Drag to move · Click for options",
		"duplicate": "Duplicate"
	},
	"slash": {
		"label": "Insert a block",
		"none": "No matching block",
		"items": {
			"text": {
				"title": "Text",
				"hint": "A plain paragraph"
			},
			"h1": {
				"title": "Heading 1",
				"hint": "A big section heading"
			},
			"h2": {
				"title": "Heading 2",
				"hint": "A medium section heading"
			},
			"h3": {
				"title": "Heading 3",
				"hint": "A small section heading"
			},
			"bullet": {
				"title": "Bulleted list",
				"hint": "A simple list"
			},
			"numbered": {
				"title": "Numbered list",
				"hint": "Steps in order"
			},
			"todo": {
				"title": "To-do list",
				"hint": "Tasks with checkboxes"
			},
			"quote": {
				"title": "Quote",
				"hint": "Set text apart"
			},
			"callout": {
				"title": "Callout",
				"hint": "A tip or a warning that stands out"
			},
			"code": {
				"title": "Code",
				"hint": "A code or command block"
			},
			"divider": {
				"title": "Divider",
				"hint": "A line between sections"
			},
			"table": {
				"title": "Table",
				"hint": "Rows and columns"
			},
			"toggle": {
				"title": "Toggle",
				"hint": "Content that opens on click"
			},
			"image": {
				"title": "Image",
				"hint": "Upload a screenshot or photo"
			},
			"file": {
				"title": "File",
				"hint": "Attach any file: PDF, document, .env, .zip…"
			},
			"page": {
				"title": "Page",
				"hint": "A sub-page inside this one, linked here"
			},
			"board": {
				"title": "Board",
				"hint": "A kanban board inside this page, linked here"
			}
		}
	},
	"mention": {
		"label": "Link to a page",
		"heading": "Link to page",
		"none": "No page found",
		"create": "New page “{{title}}”",
		"untitled": "Untitled",
		"open": "Open {{title}}",
		"inTrash": "{{title}} is in the trash"
	},
	"menu": {
		"openPage": "Open page",
		"openPageNewTab": "Open page in new tab",
		"openImage": "Open image",
		"download": "Download",
		"remove": "Remove",
		"removeLink": "Remove link",
		"cut": "Cut",
		"copy": "Copy",
		"paste": "Paste",
		"table": "Table",
		"rowAbove": "Add row above",
		"rowBelow": "Add row below",
		"columnLeft": "Add column left",
		"columnRight": "Add column right",
		"deleteRow": "Delete row",
		"deleteColumn": "Delete column",
		"headerRow": "Toggle header row",
		"headerColumn": "Toggle header column",
		"mergeCells": "Merge cells",
		"splitCell": "Split cell",
		"deleteTable": "Delete table",
		"turnInto": "Turn into",
		"deleteBlock": "Delete block"
	}
}
